"use client"
import { motion } from 'framer-motion';

const HeroBackground = () => {
    return (
        <div className="absolute inset-0 z-0 overflow-hidden bg-white pointer-events-none select-none">
            {/* 1. Animated Grid Layer */}
            <div className="absolute inset-0 z-0">
                <div
                    className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/50 to-white" />
            </div>

            {/* 2. Floating Gradient Orbs - Brighter & More Vibrant */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <motion.div
                    animate={{
                        x: [0, 50, 0],
                        y: [0, 30, 0],
                        opacity: [0.5, 0.8, 0.5], // Increased opacity for brightness
                    }}
                    transition={{
                        duration: 10,
                        repeat: Infinity,
                        repeatType: "reverse",
                        ease: "easeInOut"
                    }}
                    className="absolute top-[-10%] left-[20%] w-[500px] h-[500px] bg-blue-400/30 rounded-full blur-[100px]"
                />
                <motion.div
                    animate={{
                        x: [0, -30, 0],
                        y: [0, 50, 0],
                        opacity: [0.4, 0.6, 0.4], // Increased opacity
                    }}
                    transition={{
                        duration: 8,
                        repeat: Infinity,
                        repeatType: "reverse",
                        ease: "easeInOut",
                        delay: 1
                    }}
                    className="absolute top-[10%] right-[10%] w-[600px] h-[600px] bg-indigo-400/25 rounded-full blur-[120px]"
                />
            </div>
        </div>
    );
};

export default HeroBackground;
